import { IAnnouncementPopup } from '@app/shared/models/announcement-popups.model';
import { createAction, props } from '@ngrx/store';

export const fetchAnnouncement = createAction('fetch announcement');

export const fetchAnnouncementSuccess = createAction(
  'fetch announcement success',
  props<{ announcement: IAnnouncementPopup }>()
);

export const fetchAnnouncementFailure = createAction(
  'fetch announcement failure',
  props<{ error: string }>()
);

export const setAnnouncement = createAction(
  'set announcement',
  props<{ announcement: IAnnouncementPopup }>()
);

export const setAnnouncementFailure = createAction(
  'set announcement failure',
  props<{ error: string }>()
);

export const setDontShowAgain = createAction(
  'set dont show again',
  props<{ dontShowAgain: boolean }>()
);
